import { RoleId } from "@/entities";
import { Policy } from "@/policies";

export interface RoleContext {
  userRoleId: unknown;
}

export function isRoleContext(obj: unknown): obj is RoleContext {
  return (obj as RoleContext).userRoleId !== undefined;
}

export type RoleRule = (ctx: RoleContext) => Promise<boolean | null>;

export class RolePolicy implements Policy {
  private rule: RoleRule;
  constructor(rule: RoleRule) {
    this.rule = rule;
  }

  async can(context: unknown): Promise<boolean | null> {
    if (!isRoleContext(context)) {
      return false;
    }
    return this.rule(context);
  }
}

export const userEntityOficial = new RolePolicy(
  async (ctx) => RoleId.EntityOficial == ctx.userRoleId
);

export const userSuperAdmin = new RolePolicy(
  async (ctx) => RoleId.SuperAdmin == ctx.userRoleId
);

export const userPublisherOrOficialPolicy = new RolePolicy(
  async (ctx) =>
    RoleId.EntityOficial == ctx.userRoleId || RoleId.Publisher == ctx.userRoleId
);
